<template>
  <router-view/>
</template>

<style lang="scss">
  body {
    margin: 0;
  }
  html {
    scroll-behavior: smooth;
  }
  #app {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background: #14171A;
  }
</style>
